import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
    PreloadAllModules,
    provideRouter,
    withInMemoryScrolling,
    withPreloading,
} from '@angular/router';
import { provideFuse } from '@fuse';
import { appRoutes } from 'app/app.routes';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { provideTransloco } from 'app/core/transloco/transloco.provider';
import { provideApiUrl } from './core/http-interceptor/api-url.provider';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import 'moment/locale/fr';
import { provideToastr } from 'ngx-toastr';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

export const appConfig: ApplicationConfig = {
    providers: [
        provideToastr({
            preventDuplicates: true,
            progressBar: true,
        }),
        provideAnimations(),

        // Material Date Adapter (global) — requis par mat-datepicker / mat-calendar.
        // Le DateAdapter d'angular-calendar (plus bas) est un token distinct, pas de conflit.
        { provide: MAT_DATE_LOCALE, useValue: 'fr' },
        provideMomentDateAdapter({
            parse: { dateInput: 'DD/MM/YYYY' },
            display: {
                dateInput: 'DD/MM/YYYY',
                monthYearLabel: 'MMM YYYY',
                dateA11yLabel: 'LL',
                monthYearA11yLabel: 'MMMM YYYY',
            },
        }),

        importProvidersFrom(
            CalendarModule.forRoot({
              provide: DateAdapter,
              useFactory: adapterFactory,
            })
          ),
        provideHttpClient(),
        provideRouter(
            appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),
        // Transloco Config
        provideTransloco(),

        // Fuse
        provideAuth(),
        provideApiUrl(),
        provideIcons(),
        provideFuse({
            fuse: {
                layout: 'compact',
                scheme: 'auto',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme: 'theme-sky',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id: 'theme-sky',
                        name: 'Sky',
                    },
                    {
                        id: 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id: 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id: 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
    ],
};
